import { render, staticRenderFns } from "./duoDynamicFormMobile.vue?vue&type=template&id=abb0d7ce&scoped=true&"
import script from "./duoDynamicFormMobile.vue?vue&type=script&lang=js&"
export * from "./duoDynamicFormMobile.vue?vue&type=script&lang=js&"
import style0 from "./duoDynamicFormMobile.vue?vue&type=style&index=0&id=abb0d7ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb0d7ce",
  null
  
)

export default component.exports